import { ContractChangesByEmployeeQuery, ContractChangesByEmployeeQueryVariables } from '../../../types'
import { ApolloError, useQuery } from '@apollo/client'
import ChangeQueriesAndMutations from '../../change/ChangeQueriesAndMutations'

export default (
  employeeId: number,
): { data: ContractChangesByEmployeeQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<ContractChangesByEmployeeQuery, ContractChangesByEmployeeQueryVariables>(
    ChangeQueriesAndMutations.OpenContractChanges,
    {
      variables: {
        id: employeeId,
      },
    },
  )

  return { data, error, loading }
}
